import type { ReactNode } from 'react'
import { Link01Icon, LinkBroken02Icon } from '@systemeio/icons'
import type { Editor } from '@tiptap/core'
import { useEditorState } from '@tiptap/react'
import { cn } from 'cn'

type LinkButtonProps = {
  editor: Editor
  label: string
  onStartLinkEdit: () => void
}

export default function LinkButton({ editor, label, onStartLinkEdit }: LinkButtonProps): ReactNode {
  const active = useEditorState({
    editor,
    selector: ({ editor: ed }) => {
      if (ed.isActive('link')) return true

      const { from, to } = ed.state.selection
      return from !== to && ed.state.doc.rangeHasMark(from, to, ed.schema.marks.link)
    },
  })
  return (
    <button
      aria-pressed={active}
      className={cn(
        'relative z-10 inline-flex items-center px-2 py-1 text-text-primary/50 [&_svg]:fill-current',
        active ? 'text-text-primary' : 'hover:text-text-primary',
      )}
      onMouseDown={event => {
        event.preventDefault()
        event.stopPropagation()
        if (!active) {
          onStartLinkEdit()
          return
        }
        editor.chain().focus().extendMarkRange('link').unsetLink().run()
      }}
      title={label}
      type="button"
    >
      {active ? <LinkBroken02Icon height="15px" /> : <Link01Icon height="15px" />}
    </button>
  )
}
